import { Link } from 'react-router-dom';
import '../../assets/css/single_cource/course-aside.css';
import clientconfigwebapp, {
    check_login_appbk,
    FormatNumberByhkh,
    getLengt_arraybk,
    getLengthhk,
    modal_login_reg_bk_show
} from "../../clientconfigwebapp";
import React, {Fragment} from "react";


const CourseAside = (props) => {

    const Handler_login_show = (value_get) => {
        modal_login_reg_bk_show("login_reg_check_view_modal",value_get);
    }

  return (
    <>
      <aside className='flexColStartStart course-aside-container'>
        <div className='course-aside-img'>
            <img  src={props.page_info_data.image_src} alt={props.page_info_data.title_post} />
        </div>
        <div className='course-aside-icones'>
            <div className='flexColStartCenter course-aside-icone'>
                <svg  width="1.5rem" height="1.5rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.1792 23.9333C2.54046 23.9333 0.474609 21.8674 0.474609 12.2287C0.474609 2.59002 2.54046 0.52417 12.1792 0.52417C21.8178 0.52417 23.8837 2.59002 23.8837 12.2287C23.8837 21.8674 21.8178 23.9333 12.1792 23.9333ZM11.2038 6.37644C11.2038 5.83773 11.6405 5.40106 12.1792 5.40106C12.7178 5.40106 13.1545 5.83773 13.1545 6.37644V11.2533H18.0314C18.5701 11.2533 19.0068 11.69 19.0068 12.2287C19.0068 12.7674 18.5701 13.2041 18.0314 13.2041H12.1792C11.6405 13.2041 11.2038 12.7674 11.2038 12.2287V6.37644Z" fill="currentColor"></path></svg>
                <span>مدت دوره</span>
                <p>{ props.page_info_data.training_hours }</p>
            </div>
            <div className='flexColStartCenter course-aside-icone'>
                <svg  width="1.5rem" height="1.5rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.452148 5.7989C0.452148 10.1426 1.38314 11.0736 5.72688 11.0736C10.0706 11.0736 11.0016 10.1426 11.0016 5.7989C11.0016 1.45516 10.0706 0.52417 5.72688 0.52417C1.38314 0.52417 0.452148 1.45516 0.452148 5.7989Z" fill="currentColor"></path><path d="M0.452148 18.2664C0.452148 22.6102 1.38314 23.5412 5.72688 23.5412C10.0706 23.5412 11.0016 22.6102 11.0016 18.2664C11.0016 13.9227 10.0706 12.9917 5.72688 12.9917C1.38314 12.9917 0.452148 13.9227 0.452148 18.2664Z" fill="currentColor"></path><path d="M12.9197 5.7989C12.9197 10.1426 13.8507 11.0736 18.1944 11.0736C22.5382 11.0736 23.4691 10.1426 23.4691 5.7989C23.4691 1.45516 22.5382 0.52417 18.1944 0.52417C13.8507 0.52417 12.9197 1.45516 12.9197 5.7989Z" fill="currentColor"></path><path d="M12.9197 18.2664C12.9197 22.6102 13.8507 23.5412 18.1944 23.5412C22.5382 23.5412 23.4691 22.6102 23.4691 18.2664C23.4691 13.9227 22.5382 12.9917 18.1944 12.9917C13.8507 12.9917 12.9197 13.9227 12.9197 18.2664Z" fill="currentColor"></path></svg>
                <span>تعداد جلسات</span>
                <p>{   getLengt_arraybk(props.data_lessons_get) }</p>
            </div>
            <div className='flexColStartCenter course-aside-icone'>
                <svg  width="1.5rem" height="1.5rem" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.57753 1.67007C9.81824 0.0338038 12.2781 0.0338038 13.5188 1.67007L14.5518 3.03246L16.2456 2.79957C18.28 2.51986 20.0193 4.25924 19.7396 6.29356L19.5067 7.98737L20.8691 9.0204C22.5054 10.2611 22.5054 12.721 20.8691 13.9617L19.5067 14.9947L19.7396 16.6885C20.0193 18.7228 18.28 20.4622 16.2456 20.1825L14.5518 19.9496L13.5188 21.312C12.2781 22.9483 9.81824 22.9483 8.57753 21.312L7.5445 19.9496L5.85069 20.1825C3.81636 20.4622 2.07699 18.7228 2.3567 16.6885L2.58958 14.9947L1.2272 13.9617C-0.409067 12.721 -0.409067 10.2611 1.2272 9.0204L2.58958 7.98737L2.3567 6.29356C2.07699 4.25923 3.81637 2.51986 5.85069 2.79957L7.5445 3.03246L8.57753 1.67007ZM15.3819 10.3007C15.7415 9.94114 15.7415 9.3582 15.3819 8.99865C15.0224 8.6391 14.4394 8.6391 14.0799 8.99865L10.1275 12.951L8.93717 11.7607C8.57762 11.4011 7.99468 11.4011 7.63513 11.7607C7.27558 12.1202 7.27558 12.7032 7.63513 13.0627L9.47649 14.9041C9.83604 15.2636 10.419 15.2636 10.7785 14.9041L15.3819 10.3007Z" fill="currentColor"></path></svg>
                <span>نوع دوره</span>
                <p>آنلاین</p>
            </div>
            <div className='flexColStartCenter course-aside-icone'>
                <svg
                    fill="#3b82f6"
                    width="1.5rem" height="1.5rem"
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 330 330"
                    xmlSpace="preserve"
                >
                    <g id="SVGRepo_bgCarrier" strokeWidth={0}/>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
                    <g id="SVGRepo_iconCarrier">

                        <g id="XMLID_531_">

                            <path
                                id="XMLID_532_"
                                d="M255,210h-10c-8.284,0-15,6.716-15,15c0,8.284,6.716,15,15,15h10c8.284,0,15-6.716,15-15 C270,216.716,263.284,210,255,210z"
                            />

                            <path
                                id="XMLID_533_"
                                d="M285,150h-40c-8.284,0-15,6.716-15,15c0,8.284,6.716,15,15,15h40c8.284,0,15-6.716,15-15 C300,156.716,293.284,150,285,150z"
                            />

                            <path
                                id="XMLID_534_"
                                d="M315,90h-70c-8.284,0-15,6.716-15,15s6.716,15,15,15h70c8.284,0,15-6.716,15-15S323.284,90,315,90z"
                            />

                            <path
                                id="XMLID_535_"
                                d="M192.078,31.775c-4.878-2.61-10.796-2.324-15.398,0.744L90.459,90H15c-8.284,0-15,6.716-15,15v120 c0,8.284,6.716,15,15,15h75.459l86.221,57.481c2.51,1.673,5.411,2.519,8.321,2.519c2.427,0,4.859-0.588,7.077-1.775 c4.877-2.61,7.922-7.693,7.922-13.225V45C200,39.468,196.955,34.385,192.078,31.775z M170,256.972l-66.68-44.453 C100.856,210.876,97.961,210,95,210H30v-90h65c2.961,0,5.856-0.876,8.32-2.519L170,73.028V256.972z"
                            />

                        </g>

                    </g>
                </svg>

                <span>فایل صوتی</span>
                <p>{ props.page_info_data.audio_file }</p>
            </div>
            <div className='flexColStartCenter course-aside-icone'>
                <svg width="1.5rem" height="1.5rem" viewBox="0 0 20 20" fill="none" xmlns="https://www.w3.org/2000/svg">
                    <path fill="currentColor"
                          d="M11.4498 8.3782C12.6463 9.099 13.2446 9.4594 13.2446 10C13.2446 10.5406 12.6463 10.901 11.4498 11.6218L10.1036 12.4327C8.90703 13.1535 8.30873 13.5139 7.86001 13.2436C7.4113 12.9733 7.4113 12.2525 7.4113 10.8109V9.18911C7.4113 7.74751 7.4113 7.02671 7.86001 6.75641C8.30873 6.48611 8.90702 6.84651 10.1036 7.56731L11.4498 8.3782Z"></path>
                    <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"
                          d="M10 20C1.765 20 0 18.235 0 10C0 1.765 1.765 0 10 0C18.235 0 20 1.765 20 10C20 18.235 18.235 20 10 20ZM12.3932 12.9992C12.9177 12.6835 13.4613 12.3563 13.859 12.0269C14.2997 11.6619 14.9113 11.0118 14.9113 10C14.9113 8.98824 14.2997 8.33809 13.859 7.97312C13.4613 7.64368 12.9178 7.31652 12.3933 7.00084L10.8787 6.08847C10.3559 5.77327 9.81146 5.44505 9.33646 5.24928C8.82012 5.03647 7.91194 4.77944 7.00002 5.32876C6.11465 5.86209 5.89412 6.75913 5.81734 7.29873C5.74423 7.81251 5.74442 8.45685 5.74461 9.09275V10.9072C5.74442 11.5431 5.74423 12.1875 5.81734 12.7013C5.89412 13.2409 6.11465 14.1379 7.00002 14.6712C7.91194 15.2206 8.82012 14.9635 9.33646 14.7507C9.81146 14.5549 10.3559 14.2267 10.8787 13.9115L12.3932 12.9992Z"></path>
                </svg>
                <span>فرمت</span>
                <p>تصویری</p>
            </div>
            <div className='flexColStartCenter course-aside-icone'>
                <svg width="1.5rem" height="1.5rem" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill='currentColor' fill-rule="evenodd" clip-rule="evenodd" d="M11.6397 0C20.9066 0 22.8927 1.66715 22.8927 10.0027C22.8927 15.4208 21.9552 18.755 17.7353 18.755C15.4802 18.755 14.8094 19.8263 14.1847 20.8238C13.6405 21.6929 13.1313 22.506 11.6399 22.506C10.1487 22.506 9.63949 21.6929 9.09526 20.8238C8.47058 19.8263 7.79973 18.755 5.54457 18.755C1.3247 18.755 0.386719 15.3142 0.386719 10.0027C0.386719 1.76547 2.37287 0 11.6397 0ZM12.5775 7.502C12.5775 6.9841 12.9973 6.56425 13.5152 6.56425H16.3285C16.8464 6.56425 17.2662 6.9841 17.2662 7.502C17.2662 8.01991 16.8464 8.43975 16.3285 8.43975H13.5152C12.9973 8.43975 12.5775 8.01991 12.5775 7.502ZM6.95097 10.3153C6.43306 10.3153 6.01322 10.7351 6.01322 11.253C6.01322 11.7709 6.43306 12.1908 6.95097 12.1908H16.3285C16.8464 12.1908 17.2662 11.7709 17.2662 11.253C17.2662 10.7351 16.8464 10.3153 16.3285 10.3153H6.95097Z"></path></svg>
                <span>نظرات</span>
                <p>{props.page_list_comments.length}</p>
            </div>
        </div>

        <div className='flexRowBetCenter course-aside-price'>

                <span>قیمت دوره</span>

            <div style={{
                "display": "flex",
                "flexDirection": "column",
                "justifyContent": "center",
                "alignItems": "center",
                "alignContent": "center",
                "flexWrap": "wrap"
            }}>

                <div>
                    {String(props.page_info_data.price_line).length > 0 ?
                        <Fragment>
                            <del style={{"fontSize":"14px","marginBottom":"8px","color":"rgb(164, 154, 154)","display":"block"}}> {FormatNumberByhkh(String(props.page_info_data.price_line), ".", ",", "no")}
                                <span style={{
                                    "paddingRight": "3px",
                                    "fontSize": "11px",
                                    "color": "#767676"
                                }}>تومان</span></del>
                        </Fragment>
                        :
                        <Fragment></Fragment>
                    }
                </div>

                <span>{FormatNumberByhkh(String(props.page_info_data.price), ".", ",")}<span style={{
                    "paddingRight": "3px",
                    "fontSize": "11px",
                    "color": "#767676"
                }}>تومان</span></span>

            </div>


        </div>


          {
              props.status_buy == "yes" && check_login_appbk() == true ? (
                  <Fragment>
                      <a href={String(clientconfigwebapp.webappurl) + String(props.link_buy)} className='flexRowBetCenter course-aside-sign'>
                          <span>مشاهده دوره</span>
                          <svg width='.75rem' height='.75rem' fill='#fff' xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 494.148 494.148" xmlSpace="preserve"><g><path d="M405.284,201.188L130.804,13.28C118.128,4.596,105.356,0,94.74,0C74.216,0,61.52,16.472,61.52,44.044v406.124 c0,27.54,12.68,43.98,33.156,43.98c10.632,0,23.2-4.6,35.904-13.308l274.608-187.904c17.66-12.104,27.44-28.392,27.44-45.884 C432.632,229.572,422.964,213.288,405.284,201.188z"></path></g></svg>
                      </a>
                  </Fragment>
              ) : (
                  <Fragment>
                      {check_login_appbk() == true ? (
                          <a href={String(clientconfigwebapp.webappurl) + String(props.link_buy)} className='flexRowBetCenter course-aside-sign'>
                              <span>ثبت نام و خرید دوره</span>
                              <svg width='.75rem' height='.75rem' fill='#fff' xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 494.148 494.148" xmlSpace="preserve"><g><path d="M405.284,201.188L130.804,13.28C118.128,4.596,105.356,0,94.74,0C74.216,0,61.52,16.472,61.52,44.044v406.124 c0,27.54,12.68,43.98,33.156,43.98c10.632,0,23.2-4.6,35.904-13.308l274.608-187.904c17.66-12.104,27.44-28.392,27.44-45.884 C432.632,229.572,422.964,213.288,405.284,201.188z"></path></g></svg>
                          </a>
                      ) : (

                          <a  onClick={() => Handler_login_show( String(props.link_buy))} className='flexRowBetCenter course-aside-sign'>
                              <span>ثبت نام و خرید دوره</span>
                              <svg width='.75rem' height='.75rem' fill='#fff' xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 494.148 494.148" xmlSpace="preserve"><g><path d="M405.284,201.188L130.804,13.28C118.128,4.596,105.356,0,94.74,0C74.216,0,61.52,16.472,61.52,44.044v406.124 c0,27.54,12.68,43.98,33.156,43.98c10.632,0,23.2-4.6,35.904-13.308l274.608-187.904c17.66-12.104,27.44-28.392,27.44-45.884 C432.632,229.572,422.964,213.288,405.284,201.188z"></path></g></svg>
                          </a>

                      )}
                  </Fragment>
              )
          }




      </aside>
    </>
  );
}

export default CourseAside;